<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Orion_bin 1">
      <path
        id="layer2"
        d="M2.25 3.75H21.75M8.25 3.75V2.2125C8.25 1.82462 8.40408 1.45263 8.67836 1.17836C8.95263 0.904084 9.32462 0.75 9.7125 0.75H14.2875C14.4796 0.75 14.6697 0.787829 14.8472 0.861326C15.0246 0.934824 15.1858 1.04255 15.3216 1.17836C15.4574 1.31416 15.5652 1.47539 15.6387 1.65283C15.7122 1.83026 15.75 2.02044 15.75 2.2125V3.75M19.6875 3.75L18.6 21.4125C18.5904 21.8968 18.3937 22.3587 18.0512 22.7012C17.7087 23.0437 17.2468 23.2404 16.7625 23.25H7.2375C6.75317 23.2404 6.29135 23.0437 5.94881 22.7012C5.60627 22.3587 5.40959 21.8968 5.4 21.4125L4.3125 3.75"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        id="layer1"
        d="M12 6.75V20.25M8.25 6.75L9 20.25M15.75 6.75L15 20.25"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
